import React, { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';


const AlertBox = (props) => {
    return (
        <div>
          <Snackbar open={props.open} onClose={props.close} autoHideDuration={3000} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
            <Alert onClose={props.close} severity={props.type}>
              {props.text}
            </Alert>
          </Snackbar>
        </div>
      );
}

export default AlertBox;